import {Select} from 'antd';
import React, {SyntheticEvent, useEffect, useState} from "react";
import {SelectionMode} from '@models/index';
import packageFetcherHoc from "@hocs/packageFetcherHoc";
import {Package} from "@models/package";
import {connect} from "react-redux";
import {ApplicationState} from '../../reducers';
import {getMainClientId} from "../clients/selectors";


const Option = Select.Option;


export interface PackageMultiSelectionReturnValue {
  new_packages: string[];
  deleted_packages: string[];
  selectedItems: Package[]
}

export const packageMultiSelectionDefaultReturnValue: PackageMultiSelectionReturnValue = {
  new_packages: [],
  deleted_packages: [],
  selectedItems: []
};

type PackageSelectionProps = {
  mode: SelectionMode,
  onChange: (value: PackageMultiSelectionReturnValue) => void
  selectedPackages: Package[],
  data: Package[],
  onScroll: (e: SyntheticEvent) => void,
  handleSearch: (query: string) => void,
  fetchData: (params: object | null) => void,
  filter?: object,
  isFetched: boolean,
  initialValue: Package[] | Package | null
}


/**
 * This class handle selection of packages
 * Use Select fro ant-design because it has on scroll option
 * In terms of lazy loading of data, selected items should bre rendered separated
 * On Change callback return an object from new and deleted packages
 * @param props
 * @constructor
 */
const PackagesSelection: React.FC<PackageSelectionProps> = props => {
  const {handleSearch, onScroll, data = [], initialValue, disabled, onChange, fetchData, isFetched, mode = SelectionMode.DEFAULT} = props;
  const defaultValue = mode == SelectionMode.MULTIPLE ? [] : null;
  
  const retrieveValueFromProps = () => {
    if (mode == SelectionMode.MULTIPLE) {
      const returnValue = props.initialValue || [];
      return returnValue.map(item => item.id)
    }
    else {
      return props.initialValue ? props.initialValue.id : null
    }
  };
  
  const [value, setValue] = useState(initialValue ? retrieveValueFromProps() : defaultValue);
  
  useEffect(() => {
    const value = retrieveValueFromProps();
    setValue(value);
  }, [props.initialValue]);
  
  
  /**
   * To handle show selected packages before fetch data
   */
  const getData = () => {
    if (mode == SelectionMode.MULTIPLE) {
      let returnData = data;
      const selectedValues = props.initialValue || [];
      selectedValues.forEach(item => {
        if (returnData.findIndex(opt => opt.id === item.id) === -1) {
          returnData.push(item)
        }
      });
      
      return returnData;
    }
    else {
      return initialValue && !data.find(opt => opt.id == initialValue.id) ? [...data, initialValue] : data;
    }
  };
  
  const onChangeValue = (newValue, option) => {
    setValue(newValue);
    if (mode == SelectionMode.MULTIPLE) {
      const selectedValues = props.initialValue || [];
      const oldValue = selectedValues.map(cat => cat.id);
      const deleted_packages = oldValue.filter(item => newValue.findIndex(id => id === item) === -1);
      const new_packages = newValue.filter(item => oldValue.findIndex(id => id === item) === -1);
      props.onChange({
        deleted_packages,
        new_packages,
        selectedItems: option.map(opt => opt.props.package)
      });
    }
    else {
      onChange(option.props.package)
    }
  };
  
  const onFocus = () => {
    if (isFetched == false) {
      fetchData({});
    }
  };
  
  return (
    <Select
      showSearch
      mode={mode}
      value={value}
      disabled={disabled}
      defaultActiveFirstOption={false}
      showArrow={true}
      filterOption={false}
      onChange={onChangeValue}
      onFocus={onFocus}
      onSearch={handleSearch}
      onPopupScroll={onScroll}
      notFoundContent={null}
    >
      {getData().map(item =>
        <Option key={item.id} package={item}>{item.title}</Option>
      )}
    </Select>
  );
};




const mapStateToProps = (state : ApplicationState) => ({
  filter : {
    client_id : getMainClientId(state)
  }
});

export default connect(
  mapStateToProps,
)(packageFetcherHoc(PackagesSelection));
